import rightArrow from './rightArrow.svg'

export {
  rightArrow
}